import { render, staticRenderFns } from "./FirebaseNotificacion.vue?vue&type=template&id=1f404e1c"
import script from "./FirebaseNotificacion.vue?vue&type=script&lang=js"
export * from "./FirebaseNotificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports